
import { z } from "zod";

export const ContractorTierValues = ["CORE_PARTNER", "GROWTH", "INSURANCE_DOCUMENTATION_REVIEW", "NO_VOLUME_MATERIAL_NETWORK", "STARTER", "STRATEGIC_PARTNER"] as const;
export const ContractorTierSchema = z.enum(ContractorTierValues);
export const ContractorTier = ContractorTierSchema.enum;
export type ContractorTier = (typeof ContractorTierValues)[number];
export const ContractorTierDisplayNames = { "CORE_PARTNER": "Core Partner",
"GROWTH": "Growth",
"INSURANCE_DOCUMENTATION_REVIEW": "Insurance Documentation Review",
"NO_VOLUME_MATERIAL_NETWORK": "RMC",
"STARTER": "Starter",
"STRATEGIC_PARTNER": "Strategic Partner", } satisfies Record<ContractorTier, string>;
